import { render, staticRenderFns } from "./TipoLista.vue?vue&type=template&id=1d04e30e&"
import script from "./TipoLista.vue?vue&type=script&lang=js&"
export * from "./TipoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports